// How-to videos for the contest's bonus tasks (YouTube links), shown as a play button on the task's row.
// The key is the task's claim key (sohozkaj-backend config/contestTasks.js); a task with no entry just has no video button.
// Paste any YouTube link — youtu.be/… or youtube.com/watch?v=… (see utils/youtube.js).
export const CONTEST_TASK_VIDEOS = {
    share: 'https://youtu.be/UB1lSXEvySc',        // share SohozKaj on social media
    fb_follow: 'https://youtu.be/5ho19J9lOB0',     // follow our Facebook page
    yt_subscribe: 'https://youtu.be/rExKUWeRxMA',  // subscribe to our YouTube channel
    tiktok_follow: 'https://youtu.be/4stZkM9m1cY', // follow our TikTok account
    install_app: 'https://youtu.be/2MTrZCFUwuI',   // install the SohozKaj mobile app
    fb_review: 'https://youtu.be/5ta6uXElQDA',     // write a Facebook review (ফেসবুকে রিভিউ দিন)
    video_review: 'https://youtu.be/oIH16daDwbo',  // post a video review (ভিডিও রিভিউ দিন)
};
